import { Box } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

const defaultTheme = createTheme();
const useStyles = makeStyles(
  theme =>
    createStyles({
      root: {
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 26,
        borderRadius: 3
      },
      value: {
        position: 'absolute',
        lineHeight: '24px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }
    }),
  { defaultTheme }
);
interface WarehouseProgressBarProps {
  value: string;
  colour: string;
  percentage: number;
  icon: string;
  iconcolour: string;
  noofdiscrep: boolean;
  discrepancyColour: string;
  discrepancyIconColour: string;
  discrepancyIcon: string;
}

const WarehouseProgressBar = (props: WarehouseProgressBarProps) => {
  const theme = useTheme();

  function contrastingColor(color: any) {
    return luma(color) >= 165 ? '000' : 'fff';
  }

  function luma(color: any) {
    // color can be a hx string or an array of RGB values 0-255
    const rgb = typeof color === 'string' ? hexToRGBArray(color) : color;

    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]; // SMPTE C, Rec. 709 weightings
  }

  function hexToRGBArray(color: any) {
    color = color.replace('#', '');

    if (color.length === 3) {
      color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2);
    } else if (color.length !== 6) {
      console.log('Invalid HEX');
      console.log(value);
    }
    const rgb = [];
    for (let i = 0; i <= 2; i++) rgb[i] = parseInt(color.substr(i * 2, 2), 16);

    return rgb;
  }

  const { value, percentage, colour, noofdiscrep } = props;

  const classes = useStyles();

  let color: string;
  if (theme.palette.mode === 'light') {
    if (percentage > 33) {
      color = contrastingColor(colour);
    } else {
      color = '000';
    }
  } else {
    if (percentage > 33) {
      color = contrastingColor(colour);
    } else {
      color = 'fff';
    }
  }

  return (
    <Box className={classes.root}>
      {!noofdiscrep && (
        <Box sx={{ color: '#' + color }} className={classes.value}>
          {value}
        </Box>
      )}
      {noofdiscrep && (
        <Box sx={{ color: '#' + color }} className={classes.value}>
          {' '}
          {value}
        </Box>
      )}

      <Box style={{ backgroundColor: colour, height: '100%', maxWidth: `${percentage}%` }}></Box>
    </Box>
  );
};

export const WarehouseStatusChip = ({ value }: { value: string }) => {
  return (
    <>
      {value === 'Outstanding' && (
        <WarehouseProgressBar
          percentage={0}
          colour="#ffcc00"
          value="Outstanding"
          icon=""
          iconcolour=""
          noofdiscrep={false}
          discrepancyColour=""
          discrepancyIcon=""
          discrepancyIconColour=""
        />
      )}
      {value === 'In Progress' && (
        <WarehouseProgressBar
          percentage={33}
          colour="#ffcc00"
          value="In Progress"
          icon=""
          iconcolour=""
          noofdiscrep={false}
          discrepancyColour=""
          discrepancyIcon=""
          discrepancyIconColour=""
        />
      )}
      {(value === 'Putaway Complete' || value === 'Picking Complete') && (
        <WarehouseProgressBar
          percentage={73}
          colour="#e6ffe6"
          value={value}
          icon=""
          iconcolour=""
          noofdiscrep={false}
          discrepancyColour=""
          discrepancyIcon=""
          discrepancyIconColour=""
        />
      )}
      {(value === 'Despatched' || value === 'Landed') && (
        <WarehouseProgressBar
          percentage={100}
          colour="#85e085"
          value={value}
          icon=""
          iconcolour=""
          noofdiscrep={false}
          discrepancyColour=""
          discrepancyIcon=""
          discrepancyIconColour=""
        />
      )}
    </>
  );
};
